/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './geo-location.scss';


/*@ngInject*/
export default function GeoLocationController($scope, $rootScope, $mdMedia, $translate, $document, $mdDialog, $filter, toast, types, geoService, deviceService) {
    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.allGeoLocations = [];
        vm.geoLocations = [];
        vm.currentMobility = types.mobility.STATIC.value;
        vm.euis = [];
        vm.rowsCount = 0;
        vm.query = {
            order: '-ts',
            limit: 15,
            page: 1,
        };
        vm.limitOptions = [15, 30, 45];
        vm.filter = {};
        vm.markers = [];

        vm.reload = reload;

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.onReorder = function () {
            updateGeoLocations();
        };

        vm.onPaginate = function () {
            updateGeoLocations();
        };

        vm.onReorder = function () {
            updateGeoLocations();
        };

        vm.onPaginate = function () {
            updateGeoLocations();
        };

        deviceService.getAllEuis().then(euis => vm.euis = euis);

        resetFilters();
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    function resetFilters() {
        vm.filter = {
            timewindow: {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            },
            mobility: 0,
            eui: '',
        };
    }

    function reload() {
        vm.geoLocations.length = 0;
        vm.rowsCount = 0;
        var startTs;
        var endTs;

        vm.geoLocations = [];
        vm.allGeoLocations = [];

        if (vm.filter.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            endTs = currentTime;
            startTs = currentTime - vm.filter.timewindow.history.timewindowMs;
        } else {
            startTs = vm.filter.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.filter.timewindow.history.fixedTimewindow.endTimeMs;
        }

        if (startTs && endTs) {
            vm.geoLocationPromise = geoService.getLocalization(vm.filter.eui, vm.filter.mobility, startTs, endTs);
        }

        if (vm.geoLocationPromise) {
            vm.geoLocationPromise.then(
                (response) => {
                    if (response.warnings) {
                        toast.showWarn(response.warnings.join('<br>'));
                    }
                    if (response.loc_est) {
                        vm.allGeoLocations = response.loc_est.map(location => {
                            if (location.ts_msec) {
                                location.ts_msec *= 1000;
                            }
                            if (location.ts_msec_start) {
                                location.ts_msec_start *= 1000;
                            }
                            if (location.ts_msec_end) {
                                location.ts_msec_end *= 1000;
                            }
                            return location;
                        });
                    } else {
                        vm.allGeoLocations = [];
                    }
                    vm.currentMobility = vm.filter.mobility;
                    updateGeoLocations();
                },
                () => updateGeoLocations()
            );
        }
    }

    function updateMapMarkers() {
        if (!vm.allGeoLocations) {
            vm.allGeoLocations = [];
        }

        var locationsLength = vm.allGeoLocations.length;

        vm.markers = [];

        if (locationsLength) {
            for (let i = 0; i < locationsLength; i++) {
                const location = vm.allGeoLocations[i];
                if (vm.currentMobility === vm.types.mobility.STATIC.value) {
                    const time = String(location.ts_msec_start);
                    vm.markers.push({
                        lat: location.lat,
                        lng: location.lon,
                        alt: location.alt,
                        startTime: location.ts_msec_start,
                        endTime: location.ts_msec_end,
                        title: time,
                    });
                } else {
                    const time = String(location.ts_msec);
                    vm.markers.push({
                        lat: location.lat,
                        lng: location.lon,
                        alt: location.alt,
                        time: location.ts_msec,
                        title: time,
                    });
                }
            }
        }
    }

    function updateGeoLocations() {
        var result = $filter('orderBy')(vm.allGeoLocations, vm.query.order);
        if (!result) {
            vm.geoLocations = [];
        } else {
            vm.rowsCount = result.length;
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.geoLocations = result.slice(startIndex, startIndex + vm.query.limit);
        }
        updateMapMarkers();
    }
}



// WEBPACK FOOTER //
// ./src/app/geo-location/geo-location.controller.js